import { SET_COOKIE_CONSENT_CATEGORIES } from '../actionTypes';

export const setCookieConsentCategories = consentCategories => ({
    type: SET_COOKIE_CONSENT_CATEGORIES,
    payload: { consentCategories },
});
